import React, { useState, useEffect, useContext } from "react"
import { themeColors } from '../../../constants'
import { useParams } from 'react-router-dom';
import { Context as AuthContext } from '../../../contexts/AuthContext'
import { Context as FilterContext } from '../../../contexts/FilterPaymentContext'
import styles from './PaymentsHeader.module.scss'
import formatAmount from '../../../utilities/formatAmount'
import { FontAwesomeIcon } from '../../../components'
import { DisclaimerBox } from '../../index'
import {
  useHistory
} from '../../../hooks'

function PaymentsHeader({
  currentUserDebt,
  users,
  paymentSize,
  discliamerClosedCallback,
  accountingBookDetails,
  loading,
  resetFilter
}){

  const { state: authState } = useContext(AuthContext)
  const { state: filterState } = useContext(FilterContext)
  const [showDisclamier, setShowDisclaimer] = useState(false)
  const { group_id, accounting_book_id } = useParams()
  const history = useHistory();

  useEffect(() => {
    if (accountingBookDetails.current !== undefined) {
      setShowDisclaimer(!accountingBookDetails.current)
    }
  }, [accountingBookDetails])

  const disclaimerClosed = () => {
    handleSetAsCurrent(accounting_book_id)
  }

  const handleSetAsCurrent = (uuid) => {
    authState.api.updateCurrentAccountingBook(group_id, accounting_book_id)
      .then((res) => {
        discliamerClosedCallback()
        setShowDisclaimer(false)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  let classes = [styles.header]
  let innerBlockClasses = [styles.innerBlock]
  let filtered = !(filterState.payers.value.length === 0 && filterState.owers.value.length === 0)
  if (filterState.payers.value.length === users.length && filterState.owers.value.length === users.length)  {
    filtered = false
  }


  const filterClicked = () => {
    if (filtered) {
      resetFilter()
    } else {
      history.navigateTo("paymentsFilterPage", { group_id, accounting_book_id } )
    }
  }

  return(
    <div className={styles.headerInfocontainer}>
      <div className={classes.join(' ')}>
        {
            showDisclamier ?
              <div style={{ paddingBottom: "8px" }}>
                <DisclaimerBox closed={disclaimerClosed}>
                  如需於聊天室中使用帳款指令請將此帳本設為預設
                </DisclaimerBox >
              </div>
            : null
        }
      </div>
    </div>
  )
}


export default PaymentsHeader
